import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged, ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import {
  ClubCodeChanged,
  ClubDiscountAmountChanged,
  ClubDiscountPercentageChanged,
  ClubDiscountTypeChanged,
  ClubEndDateChanged,
  ClubEndDateCleared,
  ClubNameChanged,
  ClubStartDateChanged,
  ClubStartDateCleared,
  CreateClub,
  CreateClubSuccess,
  DeactivateClubChanged,
  ResetClub,
  SyncClubMemberChanged,
  UpdateClub,
} from '../actions/clubs-create-new.actions';
import { EditClub, EditClubSuccess } from '../actions/clubs-search.actions';
import { ClubsCreateNewState } from '../models/clubs.models';

const initialState: ClubsCreateNewState = {
  clubName: '',
  clubCode: '',
  clubStartDate: new Date(0),
  clubStartDateFormat: '',
  clubEndDate: new Date(0),
  clubEndDateFormat: '',
  clubDiscountTypes: ['Amount', 'Percentage'],
  clubDiscountType: '',
  clubDiscountAmount: '',
  clubDiscountPercentage: '',
  userSubmit: false,
  existingClub: false,
  deactivateClub: false,
  syncClubMembers: false,
  loading: false,
};

export const ClubsCreateNewReducer = createReducer(
  initialState,
  on(ClubNameChanged, (state, { clubName }) => ({
    ...state,
    clubName,
  })),
  on(ClubCodeChanged, (state, { clubCode }) => ({
    ...state,
    clubCode,
  })),
  on(ClubStartDateChanged, (state, { clubStartDate, clubStartDateFormat }) => ({
    ...state,
    clubStartDate,
    clubStartDateFormat,
  })),
  on(ClubStartDateCleared, (state) => ({
    ...state,
    clubStartDate: new Date(0),
    clubStartDateFormat: '',
  })),
  on(ClubEndDateCleared, (state) => ({
    ...state,
    clubEndDate: new Date(0),
    clubEndDateFormat: '',
  })),
  on(ClubEndDateChanged, (state, { clubEndDate, clubEndDateFormat }) => ({
    ...state,
    clubEndDate,
    clubEndDateFormat,
  })),
  on(ClubDiscountTypeChanged, (state, { clubDiscountType }) => ({
    ...state,
    clubDiscountType,
    clubDiscountAmount: '',
    clubDiscountPercentage: '',
  })),
  on(ClubDiscountAmountChanged, (state, { clubDiscountAmount }) => ({
    ...state,
    clubDiscountAmount,
  })),
  on(ClubDiscountPercentageChanged, (state, { clubDiscountPercentage }) => ({
    ...state,
    clubDiscountPercentage,
  })),
  on(DeactivateClubChanged, (state) => ({
    ...state,
    deactivateClub: !state.deactivateClub,
  })),
  on(SyncClubMemberChanged, (state) => ({
    ...state,
    syncClubMembers: !state.syncClubMembers,
  })),
  on(CreateClub, (state) => ({
    ...state,
    userSubmit: true,
  })),
  on(CreateClubSuccess, (state) => ({
    ...state,
    existingClub: true,
  })),
  on(EditClub, (state) => ({
    ...state,
    loading: true,
  })),
  on(EditClubSuccess, (state, { res }) => ({
    ...state,
    existingClub: true,
    loading: false,
    clubName: res.payload.data[0].clubName,
    clubCode: res.payload.data[0].clubCode,
    clubStartDate: new Date(res.payload.data[0].startDate ?? 0),
    clubStartDateFormat: res.payload.data[0].startDate ?? '',
    clubEndDate: new Date(res.payload.data[0].endDate ?? 0),
    clubEndDateFormat: res.payload.data[0].endDate ?? '',
    clubDiscountType: res.payload.data[0].defaultDiscountAmount
      ? 'Amount'
      : res.payload.data[0].defaultDiscountPercentage
        ? 'Percentage'
        : '',
    clubDiscountAmount: res.payload.data[0].defaultDiscountAmount ?? '',
    clubDiscountPercentage: res.payload.data[0].defaultDiscountPercentage ?? '',
  })),
  on(ResetClub, () => initialState),
  on(ActiveComponentChanged, (state, { activeComponent }) => ({
    ...state,
    clubName: '',
    clubCode: '',
    clubStartDate: new Date(0),
    clubStartDateFormat: '',
    clubEndDate: new Date(0),
    clubEndDateFormat: '',
    clubDiscountTypes: ['Amount', 'Percentage'],
    clubDiscountType: '',
    clubDiscountAmount: '',
    clubDiscountPercentage: '',
    userSubmit: false,
    existingClub: false,
    deactivateClub: false,
    syncClubMembers: false,
    loading: activeComponent === 'ClubsCreateNewComponent' ? state.loading : false,
  })),
  on(UpdateClub, (state) => ({
    ...state,
    userSubmit: true,
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState
  }))
);
